import SwiperSlider from '../base';

const selectors = {
  component: '[data-comp-vertical-slider]',
  sliderEl: '[sliderEl]',
  slide: '[slide]',
  slideTitle: '[slide-title]',
  swiperActive: 'swiper-slide-active',
  slideTitleActive: 'vertical-slide-titles__title--active',
  swiperPagination: '.swiper-pagination',
};

const swiperOptions = {
  direction: 'horizontal',
  slidesPerView: 1,
  effect: 'fade',
  autoplay: {
    delay: 2000,
    disableOnInteraction: true,
  },
  pagination: {
    el: selectors.swiperPagination,
    clickable: true,
  },
};

export default class SectionVerticalSlider extends SwiperSlider {
  static selector = selectors.component;
  constructor(containerEl) {
    super(containerEl);
    this.sliderEl = this.$container.querySelector(selectors.sliderEl);
    this.slides = this.$container.querySelectorAll(selectors.slide);
    this.slideTitles = this.$container.querySelectorAll(selectors.slideTitle);
    this.init();
    this.triggerWindowResize(); // Trigger window resize after timeout to correct visual errors in case that JS loaded before CSS
  }

  init() {
    this.determineSwiperDirection();
    this.initSwiper();
    this.determineCurrentSlide();
    this.addSlideChangeListener();
    this.addSlideTitleListeners();
    this.addWindowResizeListener();
  }

  // eslint-disable-next-line class-methods-use-this
  determineSwiperDirection() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      swiperOptions.direction = 'vertical';
    }
  }

  initSwiper() {
    this.verticalSlider = new this.Swiper(
      this.sliderEl,
      swiperOptions,
    );
  }

  determineCurrentSlide() {
    const currentSlideNumber = this.verticalSlider.realIndex;
    this.changeCurrentTitle(currentSlideNumber);
  }

  addSlideChangeListener() {
    this.verticalSlider.on('slideChange', () => {
      this.determineCurrentSlide();
    });
  }

  addSlideTitleListeners() {
    this.slideTitles.forEach(slideTitle => {
      slideTitle.addEventListener('click', () => {
        const slideIndex = slideTitle.getAttribute('slide-title');
        this.verticalSlider.slideTo(slideIndex);
      });
    });
  }

  changeCurrentTitle(currentSlideNumber) {
    this.slideTitles.forEach(slideTitle => {
      if (slideTitle.classList.contains(selectors.slideTitleActive)) {
        slideTitle.classList.remove(selectors.slideTitleActive);
      }
      const slideTitleNumber = slideTitle.getAttribute('slide-title');
      if (parseInt(slideTitleNumber, 10) === parseInt(currentSlideNumber, 10)) {
        slideTitle.classList.add(selectors.slideTitleActive);
      }
    });
  }

  addWindowResizeListener() {
    window.addEventListener('resize', () => {
      if (this.verticalSlider.params.direction === 'vertical') {
        if (!window.matchMedia('(min-width: 768px)').matches) {
          this.verticalSlider.changeDirection('horizontal');
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.verticalSlider.changeDirection('vertical');
        }
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  triggerWindowResize() {
    window.setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);
  }
}
